import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { environment } from "src/environments/environment";
import { Account } from "../types/account";
import { Log } from "../types/log";
import { Community } from "../types/community";
import { Group } from "../types/group";
import { User } from "src/app/account/data/types/user";
import { id } from "@swimlane/ngx-charts";
import { TokenStorageService } from "src/app/core/service/token-storage.service";

@Injectable({
  providedIn: "root",
})
export class AccountService {

 [x: string]: any;
  open(arg0: { key: any; entity: any }) {
    throw new Error("Method not implemented.");
  }
  constructor(
    private http: HttpClient,
  private tokenStorage: TokenStorageService) { }

  //http://102.210.244.222:8901/urassauth/

  public listActiveAccounts(): Observable<any> {
    const activeAccountsUrl = `${environment.baseUrl}/api/v1/auth/members`;

    return this.http.get<any[]>(activeAccountsUrl);
  }

  public getUsersByBranch(branchId: number): Observable<{ message: string; entity: any[] }> {
  const url = `${environment.baseUrl}/api/v1/AppUser/branch/${branchId}/relationship/officers`;
  return this.http.get<{ message: string; entity: any[] }>(url);
}


  public getBranches(): Observable<any> {
    const getBranchesUrl = `${environment.baseUrl}/api/v1/bank-branches/all`;

    return this.http.get<any[]> (getBranchesUrl);
  }

   public getBranchUsers(): Observable<any> {
    const usersUrl = `${environment.baseUrl}/api/v1/AppUser/verifying-branch-admins`;

    return this.http.get<any[]> (usersUrl);
  }

  public getAllRmOfficers(): Observable<any> {
    const usersUrl = `${environment.baseUrl}/api/v1/AppUser/all/relationship/officers`;

    return this.http.get<any[]> (usersUrl);
  }


  addBranches(data: any): Observable<any> {
    const addBranchesUrl = `${environment.baseUrl}/api/v1/bank-branches/add`;

    return this.http.post(addBranchesUrl, data)
  }

  updateBranch(id: number, data: any): Observable<any> {
    const updateBranchUrl = `${environment.baseUrl}/api/v1/bank-branches/${id}`;
    return this.http.put(updateBranchUrl, data);
  }

  activateBranch(id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/bank-branches/${id}/activate`;
    return this.http.put<any>(url, {});
  }

  deactivateBranch(id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/bank-branches/${id}/deactivate`;
    return this.http.put<any>(url, {});
  }

  public addAccount(accountData: any): Observable<any> {
    const addAccountUrl = `${environment.baseUrl}/api/v1/auth/signup`;
    return this.http.post(addAccountUrl, accountData);
  }
  public location(): Observable<any> {
    const addAccountUrl = `${environment.baseUrl}/api/v1/auth/signup`;
    return this.http.get(addAccountUrl);
  }
  loadDynamic(): Observable<any> {
    const parishId = this.tokenStorage.getUser().parishId;
    const API_URL = `${environment.baseUrl}/api/v1/reports/parish/${parishId}/members`;
    
    console.log('Parish ID:', parishId);
    console.log('API URL:', API_URL);

    return this.http.get(API_URL, {
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'application/pdf'
      })
    }).pipe(
      map((response) => {
        console.log('Response received:', response);
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }

  loadFamily(familyId: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_RL = `${environment.baseUrl}/api/v1/reports/familymembers/${familyId}`;

    return this.http.get(API_RL, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }

  // getLevelBelowUser(userId: any) {
  //   return this.http.get<{ title: string }>(`${environment.baseUrl}/api/getLevelBelow/${userId}`);
  // }
  getSubLevelNames(unitId: number): Observable<any> {
      return this.http.get(`${environment.baseUrl}/api/church-unit-levels/unit/${unitId}/sub-level-names`);
    }

  groupMemberReport(groupId: number): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_R = `${environment.baseUrl}/api/v1/reports/${groupId}/group/member`;

    return this.http.get(API_R, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }

  // groupMemberReport(selectedGroupId: any): Observable<any> {
  //   let headers = new HttpHeaders();
  //   headers.append("Accept", "application/pdf");

  //   let options: any = {
  //     responseType: "blob",
  //     withCredentials: false,
  //   };

  //   let API_R = `${environment.baseUrl}/api/v1/reports/${selectedGroupId}`;

  //   return this.http.get(API_R, options).pipe(
  //     map((response) => {
  //       return {
  //         data: new Blob([response], { type: "application/pdf" }),
  //       };
  //     })
  //   );
  // }
  communityMemberReport(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_R = `${environment.baseUrl}/api/v1/reports/${id}/community/member`;

    return this.http.get(API_R, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }
  churchMemberReport(outstationId: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_Res = `${environment.baseUrl}/api/v1/reports/${outstationId}/outstation/member`;

    return this.http.get(API_Res, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }
  communityFamilyReport(selectedCommuinityId: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_R = `${environment.baseUrl}/api/v1/reports/communityfamily/${selectedCommuinityId}`;

    return this.http.get(API_R, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }
  churchFamilyReport(selectedChurchId: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_ = `${environment.baseUrl}/api/v1/reports/churchfamily/${selectedChurchId}`;

    return this.http.get(API_, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }

  public downloadCommunityReportPDF(communityId: number): Observable<Blob> {
    // const reportsUrl = `http://localhost:8085/api/v1/reports/${communityId}/community/member`;
    const reportsUrl = `${environment.baseUrl}/api/v1/reports/${communityId}/community/member`;

    // const reportsUrl = `${environment.baseUrl}/api/v1/reports/${communityId}/community-family`;

    return this.http.get(reportsUrl, {
      responseType: 'blob'
    });
  }
//   public 
// downloadAllCommunitiesReportPDF(communityId: any){
//   const reportsUrl = `${environment.baseUrl}/api/v1/reports/${communityId}/community-family`;

//     return this.http.get(reportsUrl, {
//       responseType: 'blob'
//     });
// }




  public downloadReportPDF(stationId: number): Observable<Blob> {
    const reportsUrl = `${environment.baseUrl}/api/v1/reports/${stationId}/outstation/member`;

    return this.http.get(reportsUrl, {
      responseType: 'blob'
    });
  }

  public downloadGroupReportPDF(groupId: string): Observable<Blob> {
    const reportsUrl = `${environment.baseUrl}/api/v1/reports/${groupId}/group/member`;

    return this.http.get(reportsUrl, {
      responseType: 'blob'
    });
  }

  public downloadFamilyReportPDF(familyId: string): Observable<Blob> {
    const reportsUrl = `${environment.baseUrl}/api/v1/reports/${familyId}/family/member`;

    return this.http.get(reportsUrl, {
      responseType: 'blob'
    });
  }
  // /api/v1/reports/{id}/family/member

  public downloadPrayersReportPDF(startDate: string, endDate: string): Observable<Blob> {
    const reportsUrl = `${environment.baseUrl}/api/v1/reports/prayer/intentions/report?endDate&startDate`;

    return this.http.get(reportsUrl, {
      responseType: 'blob'
    });
  }

  // Date filtering method removed - endpoint not available


  churchGroupReport(selectedChurchId: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_ = `${environment.baseUrl}/api/v1/reports/churchgroup/${selectedChurchId}`;

    return this.http.get(API_, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }
  churchCommunityReport(selectedChurchId: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_ = `${environment.baseUrl}/api/v1/reports/churchcommunity/${selectedChurchId}`;

    return this.http.get(API_, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }
  succesfullyTransactions(): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_RL = `${environment.baseUrl}/api/v1/reports/transactions`;

    return this.http.get(API_RL, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }

  public getCountryCodes(): Observable<any> {
    const countryCodesUrl = `${environment.baseUrl}/api/v1/countrycodes`;
    return this.http.get<any[]>(countryCodesUrl);
  }


  filteredTransactions(formData: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Accept", "application/pdf");

    let options: any = {
      responseType: "blob",
      withCredentials: false,
    };

    let API_URL = `${environment.baseUrl}/api/v1/reports/transactions`;

    const params = new HttpParams({ fromObject: formData });

    options.params = params;

    return this.http.get(API_URL, options).pipe(
      map((response) => {
        return {
          data: new Blob([response], { type: "application/pdf" }),
        };
      })
    );
  }

  public members(parishId: any): Observable<any> {
    const activeAccountUrl = `${environment.baseUrl}/api/v1/auth/all/Member/${parishId}`;

    return this.http.get<any[]>(activeAccountUrl);
  }

  public fetchSystemUsers(parishId: any): Observable<any> {
    const activeAccountUrl = `${environment.baseUrl}/api/v1/auth/systemUsersDetails/${parishId}`;

    return this.http.get<any[]>(activeAccountUrl);
  }

  // get church Admins

  public fetchChurchAdmins(): Observable<any> {
    const activeAccountUrl = `${environment.baseUrl}/api/leadership/systemUsersDetails/`;

    return this.http.get<any[]>(activeAccountUrl);
  }

  public fetchChurchAdminsByRm(): Observable<any> {
    const url = `${environment.baseUrl}/api/leadership/churchAdminsByRm`;
    return this.http.get<any>(url);
  }

  public getAllMembers(): Observable<any> {
    const allMembersUrl = `${environment.baseUrl}/api/v1/auth/Member`;

    return this.http.get<any[]>(allMembersUrl);
  }

  public getAllActiveAccounts(): Observable<any> {
    const allMembersUrl = `${environment.baseUrl}​/api​/v1​/auth​/all​/Member`;

    return this.http.get<any[]>(allMembersUrl);
  }


  public getAllLocations(): Observable<any> {
    const locationUrl = `${environment.baseUrl}/api/locations`;

    return this.http.get<any[]>(locationUrl);
  }

  public getLocationsById(): Observable<any> {
    const locationUrl = `${environment.baseUrl}/api/locations/get/by/id/{id}`;

    return this.http.get<any[]>(locationUrl);
  }

  // getting getStages
  public getStages(): Observable<any> {
    const stagesUrl = `${environment.baseUrl}/api/v1/stages/all`;

    return this.http.get<any>(stagesUrl);
  }

  public getEnrollments(): Observable<any> {
    const enrollmentsUrl = `${environment.baseUrl}/api/v1/Stages/get/allStagesEnrollments`;

    return this.http.get<any[]>(enrollmentsUrl);
  }

  public getStagesApproval(memberNumber: any): Observable<any> {
    const stagesApprovalUrl = `${environment.baseUrl}/api/v1/Stages/get/by/memberNumber/${memberNumber}`;

    return this.http.get<any[]>(stagesApprovalUrl);
  }

  public getStageById(id: any): Observable<any> {
    const stagesApprovalUrl = `${environment.baseUrl}/api/v1/Stages/get/by/${id}`;

    return this.http.get<any[]>(stagesApprovalUrl);
  }
  public getCohorts(id: any, parishId): Observable<any> {
    const cohortUrl = `${environment.baseUrl}/api/cohorts/stage/${id}/${parishId}/ongoing`;

    return this.http.get<any[]>(cohortUrl);
  }



  public membersByDate(fromDate: string, toDate: string): Observable<any> {
    const activeAccountrl = `${environment.baseUrl}/api/v1/auth/memberDetails/find/by/postedTime?fromDate=${fromDate}&toDate=${toDate}`;

    return this.http.get<any[]>(activeAccountrl);
  }


  // Enquiries

  public fetchEnquiriesByTypeAndDate(typeId: any, parishId: number): Observable<any[]> {
    const url = `${environment.baseUrl}/api/enquiries/${parishId}/type/${typeId}/since-monday`;
    return this.http.get<any[]>(url);
  }

  public fetchAllEnquiriesTypes(parishId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/enquiries/${parishId}/fetch/types`;
    return this.http.get<any>(url);
  }


  public getMembersStagesByStageId(stageId: any): Observable<any> {
    const stageUrl = `${environment.baseUrl}/api/enrollments/enrollments/${stageId}`;
    return this.http.get<any>(stageUrl);
  }

  public getMembersInCohorts(cohortId: any): Observable<any> {
    const cohortUrl = `${environment.baseUrl}/api/v1/enrollments/by-cohort/${cohortId}`;

    return this.http.get<any>(cohortUrl);
  }

  //delete enquiry from database
  public deleteEnquiry(enquiryId: number): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/enquiries/delete/${enquiryId}`;
    return this.http.delete<any>(deleteUrl);
  }

  // prayer request

  // Delete prayer requests from database

  public deletePrayerRequest(enquiryId: number): Observable<any> {
    const prayerUrl = `${environment.baseUrl}/api/prayer-requests/${enquiryId}`;

    return this.http.delete<any>(prayerUrl);
  }

  // public createEnquiryTypes(typeOfEnquiry: string): Observable<any> {
  //   const createUrl = `${environment.baseUrl}/api/enquiries/add/types`;
  //   return this.http.post<any>(createUrl, typeOfEnquiry);
  // }

  public createEnquiryTypes(typeOfEnquiry: string): Observable<any> {
  const createUrl = `${environment.baseUrl}/api/enquiries/add/types`;
  const parishId = this.tokenStorage.getUser().parishId;
  
  console.log('Full URL being called:', createUrl);
  
  return this.http.post<any>(createUrl, { typeOfEnquiry, parishId });
}

public updateEnquiryType(id: number, typeOfEnquiry: string): Observable<any> {
  const updateUrl = `${environment.baseUrl}/api/enquiries/edit/types/${id}`;
  return this.http.put<any>(updateUrl, { typeOfEnquiry });
}


  public fetchPrayerRequestSinceMonday(parishId: number): Observable<any> {
    const prayerUrl = `${environment.baseUrl}/api/prayer-requests/get/${parishId}/current`;
    return this.http.get<any[]>(prayerUrl);
  }
  // GetAdmin Roles
  public getAllRoles(): Observable<any> {
    const allUrl = `${environment.baseUrl}/api/roles`;
    return this.http.get<any[]>(allUrl);
  }

  public getRoleById(id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/roles/${id}`;
    return this.http.get<any>(url);
  }

  public approveRole(id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/roles/${id}/approve`;
    return this.http.post<any>(url, {});
  }

  public rejectRole(id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/roles/${id}/reject`;
    return this.http.post<any>(url, {});
  }

  public approveUser(userId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/AppUser/${userId}/approve`;
    return this.http.post<any>(url, {});
  }

  public rejectUser(userId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/AppUser/${userId}/reject`;
    return this.http.post<any>(url, {});
  }

  public updateRolePermissions(id: number, data: any): Observable<any> {
    return this.initiateRoleUpdate(id, data);
  }

  public initiateRoleUpdate(id: number, data: any): Observable<any> {
    const url = `${environment.baseUrl}/api/roles/${id}/initiate/update`;
    return this.http.post<any>(url, data);
  }

  public initiateRoleActivation(id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/roles/${id}/initiate/activate`;
    return this.http.post<any>(url, {});
  }

  public initiateRoleDeactivation(id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/roles/${id}/initiate/deactivate`;
    return this.http.post<any>(url, {});
  }

  public initiateUserUpdate(userId: number, data: any): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/AppUser/${userId}/initiate/update`;
    return this.http.patch<any>(url, data);
  }

  public initiateUserActivation(userId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/AppUser/${userId}/initiate/activate`;
    return this.http.put<any>(url, {});
  }

  public initiateUserDeactivation(userId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/AppUser/${userId}/initiate/deactivate`;
    return this.http.put<any>(url, {});
  }

  // get all system users
  public getAllSystemUsers(): Observable<any> {
    const allUrl = `${environment.baseUrl}/api/v1/AppUser/bank-users`;
    return this.http.get<any[]>(allUrl);
  }

  public getallServicesAndMass(userName: string): Observable<any> {
    const allUrl = `${environment.baseUrl}/api/services-or-masses/allServicesAndMass?userName=${userName}`;
    return this.http.get<any[]>(allUrl);
  }
  public filterdTransactions(results: any): Observable<any> {
    const activeAccountUrl = `${environment.baseUrl}/api/v1/transaction/get/filteredTransactions`;

    return this.http.post<any[]>(activeAccountUrl, results);
  }

  // Upload Bulk Excel
  public uploadBulkExcel(formData: any): Observable<any> {
    const activeAccountUrl = `${environment.baseUrl}/api/v1/auth/upload`;

    return this.http.post<any>(activeAccountUrl, formData);
  }

  public downloadBulkTemplate(templateType: 'combined' | 'parent' | 'dependant' = 'combined'): Observable<Blob> {
    const templateUrl = `${environment.baseUrl}/api/v1/auth/upload/template`;
    return this.http.get(templateUrl, {
      params: { templateType },
      responseType: 'blob'
    });
  }

  public listGivings(): Observable<any> {
    const givingsUrl = `${environment.baseUrl}/api/v1/Giving/get/all`;

    return this.http.get<any[]>(givingsUrl);
  }
  public activeGivings(): Observable<any> {
    const activegivingsUrl = `${environment.baseUrl}/api/v1/Giving/get/Active`;

    return this.http.get<any[]>(activegivingsUrl);
  }
  public OupcomingGivings(): Observable<any> {
    const upcominggivingsUrl = `${environment.baseUrl}/api/v1/Giving/get/Upcoming`;

    return this.http.get<any[]>(upcominggivingsUrl);
  }
  public clossedGivings(): Observable<any> {
    const clossedgivingsUrl = `${environment.baseUrl}/api/v1/Giving/get/Clossed`;

    return this.http.get<any[]>(clossedgivingsUrl);
  }

  transactions(data: any): Observable<any> {
    const mpesaUrl = `${environment.baseUrl}/mobile-money/stk-transaction-request`;

    return this.http.post(mpesaUrl, data);
  }
  otherGivings(data: any): Observable<any> {
    const cashUrl = `${environment.baseUrl}/api/v1/transaction/api/v1/transaction`;

    return this.http.post(cashUrl, data);
  }
  viewTransactions(): Observable<any> {
    const trl = `${environment.baseUrl}/api/v1/transaction/get/all`;

    return this.http.get<any[]>(trl);
  }

  public getRoles(): Observable<any> {
    const rolesUrl = `${environment.baseUrl}/api/roles/assignable`;

    return this.http.get<any[]>(rolesUrl);
  }

  public addRoles(roleForm): Observable<any> {
    const addRolerl = `${environment.baseUrl}/api/roles/initiate/create`;

    return this.http.post<any[]>(addRolerl, roleForm);
  }

  public createStaffUser(userData: any): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/AppUser/create/staff`;
    return this.http.post<any>(url, userData);
  }

  public getAllPermissions(): Observable<any> {
    const perms = `${environment.baseUrl}/api/permissions/all`;

    return this.http.get<any[]>(perms);
  }

  public getGroupedPermissions(): Observable<any> {
    const perms = `${environment.baseUrl}/api/permissions/grouped`;

    return this.http.get<any>(perms);
  }

  getFamilyById(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Family/get/by/id?id=${params}`
    );
  }
  getuserById(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/AppUser/find/by/id/${params}`
    );
  }
  getMemberByGroup(groupsId: any): Observable<any> {
    return this.http.get<any>( // Change the return type here
      `${environment.baseUrl}/api/v1/auth/memberDetails/find/by/groupsId/${groupsId}`
    );
  }

  //   getFamilyByfId(params: any): Observable<any> {
  //   return this.http.get<any[]>(
  //     `${environment.baseUrl}/api/v1/Family/get/memberBy/familyId/${params}`
  //   );
  // }
  getMemberByNumber(memberNumber: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/auth/find/by/memberNumber/${memberNumber}`
    );
  }
  getUsernameById(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/AppUser/find/by/id/${params}`
    );
  }
  getGroupById(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Groups/groups/${params}/members`
    );
  }
  getMemberByMemberNumber(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/group/member/get/by/memberNumber/${params}`
    );
  }
  getMemberByCommunityId(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/auth/memberDetails/find/by/communityId/${params}`
    );
  }
  getMemberByChurchId(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/auth/memberDetails/find/by/churchId/${params}`
    );
  }
  familiesPerCommunity(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Family/by/communityId/${params}`
    );
  }

  getFamiliesByCommunityId(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Family/by/communityId/${params}`
    );
  }

  familiesPerChurch(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Family/by/churchId?churchId=${params}`
    );
  }

  familiesPerOutstation(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Family/by/outstationId/${params}`
    );
  }

  getGroupsByOutstationId(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Groups/get/getAllByOutstationId/${params}`
    );
  }

  getCommunityByOutstationId(params: any): Observable<any> {
    console.log(params)
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/outstation/outStation/${params}/communities`
    );
  }
  getFamilyByCommunityId(params: any): Observable<any> {
    console.log(params)
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Family/by/communityId/${params}`
    );
  }

  getMemberByoutStationId(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/auth/memberDetails/find/by/outstationId/${params}`
    );
  }

  addUser(data: any): Observable<any> {
    const registerUrl = `${environment.baseUrl}/api/v1/auth/signup`;

    return this.http.post(registerUrl, data);
  }
  addWebUser(data: any): Observable<any> {
    const registerUr = `${environment.baseUrl}/api/v1/AppUser/register`;

    return this.http.post(registerUr, data);
  }
  addFamilyMember(data: any): Observable<any> {
    const registerUrl = `${environment.baseUrl}/api/v1/FamilyMember/add`;

    return this.http.post(registerUrl, data);
  }
  settings(data: any): Observable<any> {
    const settingUrl = `${environment.baseUrl}/api/v1/settings/set`;

    return this.http.post(settingUrl, data);
  }
  addGiving(data: any): Observable<any> {
    const givingUrl = `${environment.baseUrl}/api/v1/Giving/add`;

    return this.http.post(givingUrl, data);
  }
  // addActivity(data: any, parishId: any): Observable<any> {
  //   const activityUrl = `http://localhost:8085/api/changa-wallets/${parishId}/add`;
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json'
  //   });

  //   return this.http.post(activityUrl, data, { headers });
  // }

  addActivity(data: any, parishId: any): Observable<any> {
    const activityUrl = `${environment.baseUrl}/api/v1/Events/${parishId}/add`;
    const headers = new HttpHeaders({
      'content-type': 'application/json'
    });
    return this.http.post(activityUrl, data, {headers});
  }

 

  addWallet(data: any): Observable<any> {
    const walletUrl = `${environment.baseUrl}/api/v1/Wallet/add`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(walletUrl, data, {headers});
  }

  addChurch(data: any): Observable<any> {
    const churchUrl = `${environment.baseUrl}/add`;

    return this.http.post(churchUrl, data);
  }
  addStage(data: any): Observable<any> {
    const stageUrl = `${environment.baseUrl}/api/v1/stages/add`;

    return this.http.post(stageUrl, data);
  }
  addOutstation(data: any): Observable<any> {
    const stationUrl = `${environment.baseUrl}/api/v1/outstation/add`;

    return this.http.post(stationUrl, data);
  }
  public getOutstation(parishId: number): Observable<any> {
    const outstationUrl = `${environment.baseUrl}/api/v1/outstation/get/all/outStationDetails/${parishId}`;
    return this.http.get<Group[]>(outstationUrl);
  }

  addCommunity(data: any): Observable<any> {
    const communityUrl = `${environment.baseUrl}/api/v1/Community/add`;

    return this.http.post(communityUrl, data);
  }
  addGroup(data: any): Observable<any> {
    const groupUrl = `${environment.baseUrl}/api/v1/Groups/add`;

    return this.http.post(groupUrl, data);
  }
  addLocation(data: any): Observable<any> {
    const locationUrl = `${environment.baseUrl}/api/locations/add`;
    return this.http.post(locationUrl, data);
  }

  addFamily(data: any): Observable<any> {
    const familyUrl = `${environment.baseUrl}/api/v1/Family/add`;

    return this.http.post(familyUrl, data);
  }

  public getGroups(): Observable<any> {
    var parishId = this.tokenStorage.getUser().parishId;

    
    const groupsUrl = `${environment.baseUrl}/api/v1/Groups/get/getAllGroups/${parishId}`;

    return this.http.get<Group[]>(groupsUrl);
  }
  //get common groups from the database
  public getCommonGroups(): Observable<any> {
    const commonGroupUrl = `${environment.baseUrl}/api/v1/Groups/get/all/others`;

    return this.http.get<any>(commonGroupUrl);
  }
  public getGroup(): Observable<any> {
   var parishId = this.tokenStorage.getUser().parishId;

    
    const groupsUl = `${environment.baseUrl}/api/v1/Groups/get/getAllGroups/${parishId}`;

    return this.http.get<Group[]>(groupsUl);
  }
  public getCommunities(parishId: any): Observable<any> {
    const communitiesUrl = `${environment.baseUrl}/api/v1/Community/get/all/${parishId}`;

    return this.http.get<Community[]>(communitiesUrl);
  }
  public getAllCommunities(parishId: any): Observable<any> {
    const communitieUrl = `${environment.baseUrl}/api/v1/Community/fetch/communities/${parishId}`;

    return this.http.get<Community[]>(communitieUrl);
  }
  public getSystemUsers(parishId: any): Observable<any> {
    const usersUrl = `${environment.baseUrl}/api/v1/auth/systemUsersDetails/${parishId}`;

    return this.http.get<any[]>(usersUrl);
  }
  public getAllGroups(): Observable<any> {
    var parishId = this.tokenStorage.getUser().parishId;
    const groupUrl = `${environment.baseUrl}/api/v1/Groups/get/getAllGroups/${parishId}`;

    return this.http.get<Group[]>(groupUrl);
  }
  public getSettings(): Observable<any> {
    const settings = `${environment.baseUrl}/api/v1/settings/`;

    return this.http.get<any[]>(settings);
  }

  public getAllfamilies(parishId: any): Observable<any> {
    const familUrl = `${environment.baseUrl}/api/v1/Family/fetch/families/${parishId}`;


    return this.http.get<any[]>(familUrl);
  }


  // The real api has an error
  public getAllOutStation(parishId: any): Observable<any> {
    const stationUrl = `${environment.baseUrl}/api/v1/outstation/get/all/outStationDetails/${parishId}`;

    return this.http.get<any[]>(stationUrl);
  }
  public getStations(parishId: any): Observable<any> {
    const stationsUrl = `${environment.baseUrl}/api/v1/outstation/fetch/all/${parishId}`;

    return this.http.get<any[]>(stationsUrl);
  }

  public updateRole(roleDetails): Observable<{ message: string }> {
    const updateRoleUrl = `${environment.baseUrl}/api/v1/auth/member/updaterole`;

    return this.http.put<{ message: string }>(updateRoleUrl, roleDetails);
  }

  verifyUserAccount(data: { memberNumber: string, verifyReason: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/AppUser/verifyAccount`;
    const headers = new HttpHeaders().set('userName', 'churchAdmin');
    return this.http.put<any>(url, data, { headers });
  }


  updateAccount(accountDetails: any, memberNumber: string): Observable<{ message: string }> {
    const updateAccountUrl = `${environment.baseUrl}/api/v1/auth/member/update/${memberNumber}`;
    return this.http.put<{ message: string }>(updateAccountUrl, accountDetails);
  }

  public activateUserAccount(userDetails): Observable<{ message: string }> {
    const activateUserAccountUrl = `${environment.baseUrl}/p2p/users/activateaccount`;

    return this.http.put<{ message: string }>(
      activateUserAccountUrl,
      userDetails
    );
  }

  deactivateUserAccount(memberNumber): Observable<{ message: string }> {
    const deactivateUserAccountUrl = `${environment.baseUrl}/api/v1/AppUser/activateaccount`;

    return this.http.put<{ message: string }>(
      deactivateUserAccountUrl,
      memberNumber
    );
  }
 

  public deactivateAccount(data: { memberNumber: string, deactivateReason: string, lockReason: string }): Observable<{ message: string }> {
    const deactivateAccountUrl = `${environment.baseUrl}/api/v1/AppUser/deactivateAccount`;
    return this.http.put<{ message: string }>(deactivateAccountUrl, data);
  }

  public unlockAccount(data: { memberNumber: string, activateReason: string, unlockReason: string }): Observable<{ message: string }> {
    const unlockAccountUrl = `${environment.baseUrl}/api/v1/AppUser/unlockAccount`;
    return this.http.put<{ message: string }>(unlockAccountUrl, data);
  }
  public unlockAdminAccounts(userId: any,  entity: any): Observable<any>{
    const unlockAdminAccountsUrl = `${environment.baseUrl}/api/v1/AppUser/${userId}/unlock`;
    return this.http.put<{ message: string; entity: any }>(unlockAdminAccountsUrl, {});
  }


  public deactivateSystemUserAccount(userId: any, data: any): Observable<{ message: string }> {
    const deactivateAccountUrl = `${environment.baseUrl}/api/v1/AppUser/${userId}/initiate/deactivate`;
    return this.http.put<{ message: string }>(deactivateAccountUrl, data);
  }

  public unlockSystemUserAccount(data: { memberNumber: string, unlockReason: string }): Observable<{ message: string }> {
    const unlockAccountUrl = `${environment.baseUrl}/api/v1/AppUser/unlockAccount`;
    return this.http.put<{ message: string }>(unlockAccountUrl, data);
  }

  public reactivateUserAccount(userDetails): Observable<{ message: string }> {
    const lockUserUrl = `${environment.baseUrl}/api/v1/AppUser/activateAccount`;

    return this.http.put<{ message: string }>(lockUserUrl, userDetails);
  }

  public deleteUser(memberNumber): Observable<{ message: string }> {
    const deleteUrl = `${environment.baseUrl}/api/v1/auth/delete/`;

    return this.http.put<{ message: string }>(deleteUrl, memberNumber);
  }

  // deleteGiving(id: number): Observable<any> {
  //   return this.http.delete(
  //     `${environment.baseUrl}/api/v1/Giving/deleteGiving/${id}`,
  //     { responseType: "text" }
  //   );
  // }
  deleteActivity(id: number): Observable<any> {
    return this.http.delete(
      `${environment.baseUrl}/api/v1/Events/delete/${id}`,
      { responseType: "text" }
    );
  }

  public restoreDeletedAccount(username): Observable<{ message: string }> {
    const restoreDeletedaccountUrl = `${environment.baseUrl}/p2p/users/restoreaccount`;

    return this.http.put<{ message: string }>(
      restoreDeletedaccountUrl,
      username
    );
  }

  getUserById(userId): Observable<any> {
    const getUserByIdUrl = `${environment.baseUrl}/api/v1/auth/find/by/appId/${userId}`;

    return this.http.get<User>(getUserByIdUrl);
  }
  public memberFilter(
    memberNumber: string,
    phoneNumber: string
  ): Observable<any> {
    const activeAccountrl = `${environment.baseUrl}/api/v1/auth/memberDetails/find/by/formData?memberNumber=${memberNumber}&phoneNumber=${phoneNumber}`;

    return this.http.get<any[]>(activeAccountrl);
  }
  public getDeletedAccounts(): Observable<Account[]> {
    const deletedAccountsUrl = `${environment.baseUrl}/p2p/users/deletedaccounts`;

    return this.http.get<Account[]>(deletedAccountsUrl);
  }

  public getLockedAccounts(): Observable<Account[]> {
    const lockedAccountsUrl = `${environment.baseUrl}/p2p/users/lockedaccounts`;

    return this.http.get<Account[]>(lockedAccountsUrl);
  }

  public getInactiveAccounts(): Observable<Account[]> {
    const inactiveAccountsUrl = `${environment.baseUrl}/p2p/users/inactiveaccounts`;

    return this.http.get<Account[]>(inactiveAccountsUrl);
  }

  public logoutUser(username): Observable<{ message: string }> {
    const logoutUrl = `${environment.baseUrl}/p2p/auth/logout`;

    return this.http.post<{ message: string }>(logoutUrl, username);
  }

  public updateDepartment(userDetails): Observable<{ message: string }> {
    const updateDepartmentsUrl = `${environment.baseUrl}/p2p/users/updatedepartment`;

    return this.http.put<{ message: string }>(
      updateDepartmentsUrl,
      userDetails
    );
  }

  public updateUserPassword(passwordDetails): Observable<{ message: string }> {
    const updateUserPasswordUrl = `${environment.baseUrl}/api/v1/AppUser/updatepassword`;

    return this.http.put<{ message: string }>(
      updateUserPasswordUrl,
      passwordDetails
    );
  }



  public updateEnrollments(stageId: number, enrollmentData: any): Observable<{ message: string }> {
    const updateUrl = `${environment.baseUrl}/api/cohorts/update/${stageId}`;
    return this.http.put<{ message: string }>(updateUrl, enrollmentData);
  }

  public updateEnrollment(enrollmentId: number, enrollmentData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/v1/enrollments/update/${enrollmentId}`;
    return this.http.patch<any>(updateUrl, enrollmentData);
  }

  public withdrawEnrollment(enrollmentId: number, reason: string): Observable<any> {
    const withdrawUrl = `${environment.baseUrl}/api/v1/enrollments/withdraw/${enrollmentId}`;
    return this.http.patch<any>(withdrawUrl, { reason });
  }



  public updateFirstTimePassword(
    passwordDetails
  ): Observable<{ message: string }> {
    const updateUserPasswordUrl = `${environment.baseUrl}/ebm/auth/resetpassword`;

    return this.http.put<{ message: string }>(
      updateUserPasswordUrl,
      passwordDetails
    );
  }

  public updateUser(user, memberNumber): Observable<{ message: string }> {
    const updateUserUrl = `${environment.baseUrl}/api/v1/auth/member/update/${memberNumber}`;

    return this.http.put<{ message: string }>(updateUserUrl, user);
  }

 public VerifyRM(userId: any): Observable<{ message: string; entity: any }> {
  const updateUserUrl = `${environment.baseUrl}/api/v1/AppUser/${userId}/verify`;
  return this.http.put<{ message: string; entity: any }>(updateUserUrl, {});
}

 public VerifySystemUser(id: number): Observable<{ message: string; entity: any }> {
  const updateUserUrl = `${environment.baseUrl}/api/v1/AppUser/verify/${id}`;
  return this.http.put<{ message: string; entity: any }>(updateUserUrl, {});
}



  public deleteSystemUser(user, userId): Observable<{ message: string }> {
    const updateUserUrl = `${environment.baseUrl}/api/v1/AppUser/${userId}/initiate/delete`;
    return this.http.delete<{ message: string }>(updateUserUrl);
  }

  public deleteUnitProfile(churchId): Observable<{ message: string }> {
    const updateUserUrl = `${environment.baseUrl}/api/church-unit-profile/delete/${churchId}`;

    return this.http.delete<{ message: string }>(updateUserUrl);
  }

  public updateSystemUser(user, id): Observable<{ message: string }> {
    const updateUserUrl = `${environment.baseUrl}/api/v1/AppUser/update/${id}`;

    return this.http.patch<{ message: string }>(updateUserUrl, user);
  }

  public updateChurchUnitProfile(id, data): Observable<{ message: string }> {
    const updateUserUrl = `${environment.baseUrl}/api/church-unit-profile/update/${id}`;

    return this.http.put<{ message: string }>(updateUserUrl, data);
  }


  public updateGiving(giving): Observable<{ message: string }> {
    const updateUrl = `${environment.baseUrl}/api/v1/Giving/updateGiving`;

    return this.http.put<{ message: string }>(updateUrl, giving);
  }

  public getAccountLogs(username): Observable<Log[]> {
    const accountLogsUrl = `${environment.baseUrl}/church/audit/alllogs/${username}`;

    return this.http.get<Log[]>(accountLogsUrl);
  }

  public getDailyAccountLogs(uname, stime): Observable<Log[]> {
    const dailyAccountLogsUrl = `${environment.baseUrl}/church/audit/todaylogs`;

    return this.http.get<Log[]>(dailyAccountLogsUrl, {
      params: { uname, stime },
    });
  }

  addLimit(limitConfig: any): Observable<any> {
    return this.http.post(
      `${environment.baseUrl}/emtbulksmsapi/ebs/smslimits/add`,
      limitConfig
    );
  }

  public getLimitByUsername(userName): Observable<any> {
    const usersUrl = `${environment.baseUrl}/ebs/smslimits/list/${userName}`;

    return this.http.get<any>(usersUrl);
  }

  addEmailLimit(limitConfig: any): Observable<any> {
    return this.http.post(`${environment.baseUrl}/p2p/limits/add`, limitConfig);
  }

  public updateUserDepartment(user): Observable<{ message: string }> {
    const updateUserUrl = `${environment.baseUrl}/p2p/users/updatedepartment`;

    return this.http.put<{ message: string }>(updateUserUrl, user);
  }

  getDepartments(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.baseUrl}/p2p/departments/view`);
  }

  public updateChurch(id: any, updateData: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/updateParish/${id}`, updateData);
  }
  public deleteParish(parishId: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/deleteParish/${parishId}`;

    return this.http.delete(deleteUrl);
  }
  public deleteStages(stageId: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/v1/admin/stages/delete/${stageId}`;

    return this.http.delete(deleteUrl);
  }
  public deleteOutstation(outstationId: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/v1/OutStation/outStation/${outstationId}`;

    return this.http.delete(deleteUrl);
  }
  public deleteCommunity(communityId: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/v1/Community/communities/${communityId}`;

    return this.http.delete(deleteUrl);
  }
  public deleteGroup(groupId: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/v1/Groups/groups/${groupId}`;

    return this.http.delete(deleteUrl);
  }
  public deleteLocation(id: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/locations/delete/by/id/{id}/${id}`;

    return this.http.delete(deleteUrl);
  }
  public deleteGiving(givingId: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/v1/Giving/deleteGiving/${givingId}`;

    return this.http.delete(deleteUrl);
  }

  public deleteActivities(id: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/v1/Events/delete/${id}`;

    return this.http.delete(deleteUrl);
  }

  public deleteFamily(id: any): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/v1/Family/family/${id}`;

    return this.http.delete(deleteUrl);
  }

  public updateFamily(id: any, updData: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/api/v1/Family/updateFamily/${id}`, updData);
  }

  public updateCommunity(id: any, updData: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/api/v1/Community/updateCommunity/${id}`, updData);
  }
  public updateStages(stageId: any, updData: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/api/v1/admin/stages/update/${stageId}`, updData);
  }

  public updateGroup(id: any, updData: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/api/v1/Groups/updateGroup/${id}`, updData);
  }

  public updatOutStation(id: any, updData: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/api/v1/OutStation/updateOutStation/${id}`, updData);
  }

  public updateLocation(id: any, updData: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/api/locations/update/by/id/{id}/${id}`, updData);
  }

  getoutStationDetails(parishId: any): Observable<any> {
    const getOutstationUrl = `${environment.baseUrl}/api/v1/outstation/get/all/outStationDetails/${parishId}`;
    return this.http.get<any[]>(getOutstationUrl);
  }

  addEnrollments(data: any): Observable<any> {
    const enrollmentUrl = `${environment.baseUrl}/api/v1/enrollments/enroll-multiple`;

    return this.http.post(enrollmentUrl, data);
  }

  addEnrollment(data: any): Observable<any> {
    const enrollUrl = `${environment.baseUrl}/api/v1/enrollments/enroll`;

    return this.http.post(enrollUrl, data);
  }

  // // Retrieves a single activity record by its id
  // getActivityById(id: string): Observable<any> {
  //   return this.http.get<any>(`${this.baseUrl}/${id}`);
  // }
  getActivityById(params: any): Observable<any> {
    return this.http.get<any[]>(
      `${environment.baseUrl}/api/v1/Events/get/by/${params}`
    );
  }

   // Updates an activity record by its id with the provided form data
   updateActivity(id: string, formData: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/api/v1/Events/update/${id}`, formData);
  }

  addDonations(churchUnitId: number, donationData: any): Observable<any> {
    const donationUrl = `${environment.baseUrl}/api/donations/unit/${churchUnitId}/create`;

    return this.http.post(donationUrl, donationData);
  }

  getDonations(churchUnitId: number): Observable<any> {
    const donationUrl = `${environment.baseUrl}/api/donations/unit/${churchUnitId}/all`;

    return this.http.get(donationUrl);
  }

  updateDonation(id: number, donationData: any): Observable<any> {
    const donationUrl = `${environment.baseUrl}/api/donations/update/${id}`;

    return this.http.put(donationUrl, donationData);
  }

  getChurchUnitById(id: number): Observable<any> {
    const churchUnitUrl = `${environment.baseUrl}/church-units/${id}`;

    return this.http.get(churchUnitUrl);
  }

  deleteDonation(id: number): Observable<any> {
    const donationUrl = `${environment.baseUrl}/api/donations/delete/${id}`;

    return this.http.delete(donationUrl);
  }

    // Get leaf units (descendants) of a church unit
  public getLeafUnits(parishId: number): Observable<any[]> {
    const url = `${environment.baseUrl}/api/v1/outstation/fetch/all/${parishId}`;
    return this.http.get<any[]>(url);
  }

  // Get eligible Caritas accounts for a church unit
  public getEligibleCaritasAccounts(churchUnitId: number): Observable<any> {
    return this.http.get(`${environment.baseUrl}/api/v1/church-units/${churchUnitId}/eligible-caritas-accounts`);
  }

  // Generate detailed donation report
  public getDetailedDonationReport(churchUnitId: number, donationListId: number): Observable<Blob> {
    const reportUrl = `${environment.baseUrl}/api/v1/reports/donations/detail/${churchUnitId}/${donationListId}`;
    return this.http.get(reportUrl, { responseType: 'blob' });
  }

  // Generate summary donation report
  public getSummaryDonationReport(churchUnitId: number, donationListId: number): Observable<Blob> {
    const reportUrl = `${environment.baseUrl}/api/v1/reports/donations/summary/${churchUnitId}/${donationListId}`;
    return this.http.get(reportUrl, { responseType: 'blob' });
  }

  // Mission and Vision API methods
  public getMissionVision(churchUnitId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/mission-vision/${churchUnitId}`;
    return this.http.get(url);
  }

  public createMissionVision(churchUnitId: number, data: { missionStatement: string; visionStatement: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/mission-vision/${churchUnitId}`;
    return this.http.post(url, data);
  }

  public updateMissionVision(churchUnitId: number, data: { missionStatement: string; visionStatement: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/mission-vision/${churchUnitId}`;
    return this.http.put(url, data);
  }

  public deleteMissionVision(churchUnitId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/mission-vision/${churchUnitId}`;
    return this.http.delete(url);
  }

  public confirmMpesaPayment(payload: { mpesaRef: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/admin/caritas/accounts/mpesa-query`;
    return this.http.post(url, payload);
  }

  public getBankStatement(payload: { country: string; accountNo: string; fromDate: string; toDate: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/admin/caritas/accounts/statement`;
    return this.http.post(url, payload);
  }

  public getMiniStatement(payload: { country: string; accountNo: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/admin/caritas/accounts/mini-statement`;
    return this.http.post(url, payload);
  }

  public getGroupMemberCount(churchUnitId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/group/member/count/${churchUnitId}`;
    return this.http.get(url);
  }

  public getAccountStatement(accountNo: string, startDate: string, endDate: string): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/internal-reports/accounts/statement-data`;
    return this.http.get(url, { params: { accountNo, startDate, endDate } });
  }

  public getAccountStatementPDF(accountNo: string, startDate: string, endDate: string): Observable<Blob> {
    const url = `${environment.baseUrl}/api/v1/internal-reports/accounts/statement-pdf`;
    return this.http.get(url, { params: { accountNo, startDate, endDate }, responseType: 'blob' });
  }

  // Church History API methods
  public getChurchHistory(churchUnitId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/history/${churchUnitId}`;
    return this.http.get(url);
  }

  public createChurchHistory(churchUnitId: number, data: { content: string; title: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/history/${churchUnitId}`;
    return this.http.post(url, data);
  }

  public updateChurchHistory(paragraphId: number, data: { content: string; title: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/history/paragraphs/${paragraphId}`;
    return this.http.put(url, data);
  }

  public deleteChurchHistory(paragraphId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/history/paragraphs/${paragraphId}`;
    return this.http.delete(url);
  }

  //social media platforms
  public getSocialLinks(churchUnitId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/social-links/${churchUnitId}`;
    return this.http.get(url);
  }

  public createSocialLink(churchUnitId: number, data: { platform: string; url: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/social-links/${churchUnitId}`;
    return this.http.post(url, data);
  }

  public updateSocialLink(linkId: number, data: { platform: string; url: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/social-links/${linkId}`;
    return this.http.put(url, data);
  }

  public deleteSocialLink(linkId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/social-links/${linkId}`;
    return this.http.delete(url);
  }

  // Songs API methods
  public getSongs(churchUnitId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/songs/${churchUnitId}/active`;
    return this.http.get(url);
  }

  public createSong(churchUnitId: number, data: { title: string; artist: string; lyrics: string; videoUrl: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/songs/${churchUnitId}`;
    return this.http.post(url, data);
  }

  public updateSong(songId: number, data: { title: string; artist: string; lyrics: string; videoUrl: string }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/songs/${songId}`;
    return this.http.put(url, data);
  }

  public deleteSong(songId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/songs/${songId}`;
    return this.http.delete(url);
  }

  // Prayers API methods
  public getActivePrayers(churchUnitId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/prayers/${churchUnitId}/active`;
    return this.http.get(url);
  }

  public createPrayer(churchUnitId: number, data: { title: string; content: string; isEvergreen: boolean }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/prayers/${churchUnitId}`;
    return this.http.post(url, data);
  }

  public updatePrayer(prayerId: number, data: { title: string; content: string; isEvergreen: boolean }): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/prayers/${prayerId}`;
    return this.http.put(url, data);
  }

  public deletePrayer(prayerId: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/prayers/${prayerId}`;
    return this.http.delete(url);
  }

  public createReadings(churchUnitId: number, data: { readingDate: string; title: string; passageReference: string; passageText: string}): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/bible-readings/${churchUnitId}`;
    return this.http.post(url, data);
  }

  public updateReadings(Id: number, data: { readingDate: string; title: string; passageReference: string; passageText: string}): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/bible-readings/${Id}`;
    return this.http.put(url, data);
  }

  public getReadings(churchUnitId: number): Observable<any> {
    const url =`${environment.baseUrl}/api/v1/app-resources/bible-readings/by-date/${churchUnitId}`;
    return this.http.get(url);
  }
  
  public deleteReadings(Id: number): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/app-resources/bible-readings/${Id}`;
    return this.http.delete(url);
  }
}
